// reducers/SutraPoints.js

/**
 * Reducer for tracking the current sutra points.
 * @param {number} state - The current points for the sutra (default: 0).
 * @param {Object} action - Redux action.
 * @returns {number} The updated sutra points.
 */
const initialState = 0;

const sutrapointsReducer = (state = initialState, action) => {
  if (action.type === "SET_POINTS") {
    // Sets the current sutra points to the payload value
    return action.payload;
  }
  // Returns the current state for any unrelated action
  return state;
};

export default sutrapointsReducer;
